import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Modal from '../Global/Modals/Modal';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';
import ButtonStyles from '../../styles/button';
import SpacingStyles from '../../styles/helpers/spacing';
import { AppContext } from '../../AppProvider';
import GlobalProps from './../../GlobalProps/GlobalProps';
import ErrorNotification from '../common/ErrorNotification';

const styles = theme => ({
  footer: {
    display: 'flex',
    position: 'relative'
  },
  cancelButton: {
    position: 'absolute',
    right: 0,
    top: -6
  },
  organizationListContent: {
    height: '300px',
    overflow: 'hidden',
    overflowY: 'auto',
    marginTop: theme.spacing.unit * 1.25
  },
  organizationName: {
    '&:hover': {
      backgroundColor: 'whitesmoke !important'
    }
  }
});

export class OrgSwitcher extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  state = {
    error: null
  };

  componentDidMount() {}

  _handleOnClose = () => {
    this.props.onClose();
  };

  _handleAccessOrganization = async orgId => {
    const { globalProps } = this.context;

    try {
      const GP = new GlobalProps();
      const updatedGlobalProps = await GP.setupOrganization(orgId, globalProps);
      this.context.updateGlobalProps(updatedGlobalProps);
      this.props.history.push('/dashboard');
      this.props.onClose();
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { t, classes, open } = this.props;
    const { userOrganizations, currentOrgId } = this.context.globalProps;

    if (this.state.error) {
      return <ErrorNotification message="Error loading page" />;
    }

    return (
      <Modal
        open={open}
        onClose={this._handleOnClose}
        body={
          <Fragment>
            <div>
              <p className={classes.headline8}>{t('Organizations')}</p>
            </div>
            <List className={classes.organizationListContent}>
              {userOrganizations
                .filter(org => {
                  return org.id !== currentOrgId;
                })
                .map(org => {
                  return (
                    <Fragment key={org.id}>
                      <ListItem
                        button
                        className={classes.organizationName}
                        onClick={() => this._handleAccessOrganization(org.id)}
                      >
                        <ListItemText>{org.name}</ListItemText>
                      </ListItem>
                    </Fragment>
                  );
                })}
            </List>
            <Fragment>
              <div className={classnames(classes.footer)}>
                <div className={classes.spacer} />
                <Button
                  className={classnames(classes.button, classes.cancelButton)}
                  onClick={this._handleOnClose}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
              </div>
            </Fragment>
          </Fragment>
        }
      />
    );
  }
}

OrgSwitcher.contextType = AppContext;
const translatedOrgSwitcher = withNamespaces()(OrgSwitcher);
export default withRouter(
  withStyles(
    combineStyles(
      styles,
      LayoutStyles,
      TypographyStyles,
      ButtonStyles,
      SpacingStyles
    )
  )(translatedOrgSwitcher)
);
